var map = {
	"./emmet/emmet.plugin": [
		5798,
		798
	],
	"./recording/recording.plugin": [
		5596,
		596
	],
	"./vim/vim.plugin": [
		7936,
		936
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3425;
module.exports = webpackAsyncContext;